import { render } from "./AssetLandingView.vue?vue&type=template&id=a463ce56&scoped=true"
import script from "./AssetLandingView.vue?vue&type=script&lang=js"
export * from "./AssetLandingView.vue?vue&type=script&lang=js"

import "./AssetLandingView.vue?vue&type=style&index=0&id=a463ce56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a463ce56"]])

export default __exports__